/*
 * ctf-cart-refresh.js
 * Mantiene el contador del cart icon del header (.ctf-cart-count) sincronizado
 * con el cart real del usuario, sin tener que refrescar la página.
 *
 * Cómo funciona:
 *   - Intercepta window.fetch y XMLHttpRequest para detectar mutaciones del cart
 *     (/cart/add, /cart/change, /cart/update, /cart/clear).
 *   - Después de cada mutación exitosa, fetch a /cart.js y actualiza el badge.
 *   - Si el cart estaba vacío y se agrega un item, crea el <span> del badge.
 *   - Si el badge ya existe y el cart queda en 0, lo remueve.
 *   - Pop animation al cambiar.
 *   - Re-sync en pageshow (volver con back/forward) y en focus de la ventana
 *     (caso: el user agregó algo en otra tab).
 *
 * Expone window.ctfRefreshCartCount() para forzar refresh manual si hace falta.
 */
(function () {
  'use strict';

  var CART_MUTATION_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|#|$)/i;

  function findCartButton() {
    return document.querySelector('.ctf-cart-btn');
  }

  function setCount(n) {
    var btn = findCartButton();
    if (!btn) return;
    var badge = btn.querySelector('.ctf-cart-count');
    var prev  = badge ? parseInt(badge.textContent, 10) || 0 : 0;

    if (n > 0) {
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'ctf-cart-count';
        btn.appendChild(badge);
      }
      badge.textContent = String(n);
      badge.setAttribute('aria-label', n + ' items in cart');
      if (n !== prev) {
        // Trigger pop animation (re-trigger por reflow)
        badge.classList.remove('is-bump');
        void badge.offsetWidth;
        badge.classList.add('is-bump');
      }
    } else if (badge) {
      badge.remove();
    }
  }

  var inFlight = false;
  function refresh() {
    if (inFlight) return;
    inFlight = true;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (data) {
        if (data && typeof data.item_count === 'number') setCount(data.item_count);
      })
      .catch(function () {})
      .then(function () { inFlight = false; });
  }

  // ── Interceptor: fetch ────────────────────────────────────────
  if (window.fetch) {
    var origFetch = window.fetch.bind(window);
    window.fetch = function (input, init) {
      var url = typeof input === 'string'
        ? input
        : (input && input.url) || '';
      var promise = origFetch(input, init);
      if (CART_MUTATION_RE.test(url)) {
        promise.then(function (res) {
          if (res && res.ok) refresh();
        }).catch(function () {});
      }
      return promise;
    };
  }

  // ── Interceptor: XMLHttpRequest (legacy) ──────────────────────
  if (window.XMLHttpRequest) {
    var XHR = window.XMLHttpRequest.prototype;
    var origOpen = XHR.open;
    var origSend = XHR.send;
    XHR.open = function (method, url) {
      this.__ctfCartUrl = url;
      return origOpen.apply(this, arguments);
    };
    XHR.send = function () {
      var self = this;
      if (CART_MUTATION_RE.test(self.__ctfCartUrl || '')) {
        self.addEventListener('load', function () {
          if (self.status >= 200 && self.status < 300) refresh();
        });
      }
      return origSend.apply(this, arguments);
    };
  }

  // ── Sync triggers ─────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  // Back/forward navigation con bfcache
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) refresh();
  });
  // Cambio de tab (ej: agregó algo en otra tab)
  window.addEventListener('focus', refresh);

  // Manual API
  window.ctfRefreshCartCount = refresh;

  // Compat: dispatch event que otros scripts pueden escuchar
  document.addEventListener('cart:refresh', refresh);
})();
